import React from 'react'

const TextFFXIV = ({
    text,
    className,
    style
}: {
    text: string;
    className?: string;
    style?: React.CSSProperties;
}) => {
    return (
        <span
            className={`text-shadow-border shadow-black ${className}`}
            style={style}
        >
            <span>{text}</span>
        </span>
    )
}

export default TextFFXIV